import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import {
  DeletedPending,
  RecentlyDeleted,
} from "@/client/components/recently-deleted";
import { clientCopy } from "@/client/copy";
import { pageTitle } from "@/client/lib/page-title";
import { PENDING_MS } from "@/client/lib/pending";
import { ensureTenantData } from "@/client/lib/session";
import { peopleQuery } from "@/features/people/people-query";
import { deletedQuery } from "@/features/tasks/deleted-query";
import {
  DELETED_SEARCH_DEFAULTS,
  type DeletedShow,
  deletedSearch,
} from "@/features/tasks/schemas";

/** Drawn full width: the frame has no settings nav beside it. */
export const Route = createFileRoute("/_authenticated/$slug/deleted")({
  head: ({ match }) => ({
    meta: [
      {
        title: pageTitle(clientCopy.nav.deleted, match.context.companyName),
      },
    ],
  }),
  validateSearch: deletedSearch,
  search: { middlewares: [stripSearchParams(DELETED_SEARCH_DEFAULTS)] },
  loader: async ({ context }) => {
    await Promise.all([
      ensureTenantData(context.queryClient, deletedQuery),
      ensureTenantData(context.queryClient, peopleQuery),
    ]);
  },
  pendingMs: PENDING_MS,
  pendingComponent: Pending,
  component: Deleted,
});

function Pending() {
  return (
    <DeletedPending
      role={Route.useRouteContext().role}
      show={Route.useSearch().show}
      onShow={useShow()}
    />
  );
}

function Deleted() {
  const { slug } = Route.useParams();
  const { role } = Route.useRouteContext();
  const { show } = Route.useSearch();

  return (
    <RecentlyDeleted slug={slug} role={role} show={show} onShow={useShow()} />
  );
}

function useShow() {
  const navigate = Route.useNavigate();
  // Replaced so Back leaves the screen instead of stepping through each filter.
  return (next: DeletedShow) =>
    navigate({ search: { show: next }, replace: true });
}
